// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".date-picker-container{position:relative;width:100%}.flatpickr-wrapper{width:100%}.flatpickr-calendar.static.open{position:absolute;top:100%}.date-label{display:none!important}", ""]);
// Exports
module.exports = exports;
